const userEvents = {
  CREATE_INVOICE_CLICKED: "Create Invoice Clicked",
  BRANDING_UPDATED: "Branding Updated",
};

export default userEvents;
